<template>
  <div class="py-4">
    <carousel ref="carousel" v-bind="carouselConfig" @slide-end="handleSlideEnd"> 
      <slide v-for="file in uniqueFiles" :key="file">
        <TaskList
          :tasks="tasksByFile(file)"
          :fileName="file"
          @taskCreated="handleTaskCreated"
          @scrolling="handleScrolling"
        />
      </slide>
    </carousel>
  </div>
</template>

<script>
import { ref, computed, onMounted, nextTick } from 'vue'
import Task from '../models/Task'
import { useRouter, useRoute } from 'vue-router'

import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide } from 'vue3-carousel'
import TaskList from '../components/TaskList.vue'

export default {
  name: 'TaskListView',
  components: {
    Carousel,
    Slide,
    TaskList
  },
  setup() {
    const tasks = ref([]) // Use ref to create a reactive variable
    const router = useRouter() // Use Vue Router
    const route = useRoute() // Use Vue Router
    const carousel = ref(null)

    const isScrolling = ref(false)

    onMounted(async () => {
      await loadTasks()
      scrollToSlideFromUrl()
    })

    const uniqueFiles = computed(() => {
      const files = tasks.value.map(task => task.file)
      return [...new Set(files)]
    })

    const carouselConfig = ref({
      perPage: 1,
      wrapAround: true,
      enabled: true
    })


    const tasksByFile = (file) => {
      
      return tasks.value
        .filter(task => task.title.trim() !== '')
        .filter(task => task.file === file)
    }

    const handleTaskCreated = () => {
      console.log('Task created')
      loadTasks()
    }

    const loadTasks = async () => {
      console.log('load tasks')
      try {
        tasks.value = await Task.list()
      } catch (error) {
        console.error(error)
      }
    }

    const handleSlideEnd = (data) => {
      console.log('Slide end', data.currentSlideIndex)
      let file = uniqueFiles.value[data.currentSlideIndex]
      
      file = fileNameToUrlPart(file)
    
      // Add the filename to the URL using vue router
      router.replace({ path: `/tasks/${file}` })

      console.log('File', file)
    }

    const fileNameToUrlPart = (fileName) => {
      // Strip of the ".md" file extension
      fileName = fileName.replace(/\.md$/, '')
      // Replace spaces with dashes
      fileName = fileName.replace(/ /g, '-')
      // To lowercase
      fileName = fileName.toLowerCase()

      return fileName  
    }


    const scrollToSlideFromUrl = () => {
      const fileFromUrl = route.params.listName
      if (fileFromUrl) {

        const fileIndex = uniqueFiles.value.findIndex(file => fileNameToUrlPart(file) === fileFromUrl)
        if (fileIndex !== -1) {
          nextTick(() => {
            carousel.value.slideTo(fileIndex)
          })
        }
      }
    }


    const handleScrolling = (scrolling) => {
      if (scrolling) {
        // carouselConfig.value.enabled = false
        carouselConfig.value.touchDrag = false
        carouselConfig.value.mouseDrag = false

      } else {
        // carouselConfig.value.enabled = true
        carouselConfig.value.touchDrag = true
        carouselConfig.value.mouseDrag = true
      }
    }


    return {
      uniqueFiles,
      tasksByFile,
      handleTaskCreated,
      carouselConfig,
      handleSlideEnd,
      carousel,
      
      isScrolling,
      handleScrolling,
      
    }
  }
}
</script>

<style>
/* Add your styles here */
.carousel__slide {
  flex-shrink: 0;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  transform: translateZ(0);
}

.slide-content {
  width: 95%;
  max-width: 95%;
}
</style>